/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Configuration validation request
 * @export
 * @interface ConfigurationValidationRequest
 */
export interface ConfigurationValidationRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationValidationRequest
     */
    integrationId?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ConfigurationValidationRequest
     */
    _configuration?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ConfigurationValidationRequest interface.
 */
export function instanceOfConfigurationValidationRequest(value: object): value is ConfigurationValidationRequest {
    return true;
}

export function ConfigurationValidationRequestFromJSON(json: any): ConfigurationValidationRequest {
    return ConfigurationValidationRequestFromJSONTyped(json, false);
}

export function ConfigurationValidationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationValidationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'integrationId': json['integrationId'] == null ? undefined : json['integrationId'],
        '_configuration': json['configuration'] == null ? undefined : json['configuration'],
    };
}

export function ConfigurationValidationRequestToJSON(json: any): ConfigurationValidationRequest {
    return ConfigurationValidationRequestToJSONTyped(json, false);
}

export function ConfigurationValidationRequestToJSONTyped(value?: ConfigurationValidationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'integrationId': value['integrationId'],
        'configuration': value['_configuration'],
    };
}

